import React from 'react';
import { Modal, Typography, Space, Tag, Button } from 'antd';
import { WalletOutlined, WarningOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;

interface InsufficientCreditsModalProps {
  open: boolean;
  onClose: () => void;
  required: number;
  balance: number;
  action: string;
}

const InsufficientCreditsModal: React.FC<InsufficientCreditsModalProps> = ({
  open,
  onClose,
  required,
  balance,
  action,
}) => {
  const navigate = useNavigate();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
        <Button
          key="credits"
          type="primary"
          icon={<WalletOutlined />}
          onClick={() => {
            onClose();
            navigate('/credits');
          }}
        >
          View My Credits
        </Button>,
      ]}
      title={
        <Space>
          <WarningOutlined style={{ color: '#faad14', fontSize: 20 }} />
          <span>Insufficient Credits</span>
        </Space>
      }
    >
      <div className="py-4">
        <Text className="text-gray-600 block mb-4">
          You don't have enough credits to perform this action.
        </Text>

        <div className="bg-gray-50 rounded-lg p-4 space-y-3">
          <div className="flex justify-between items-center">
            <Text className="text-gray-500">Action</Text>
            <Tag color="blue">{action.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</Tag>
          </div>
          <div className="flex justify-between items-center">
            <Text className="text-gray-500">Credits Required</Text>
            <Text strong className="text-orange-600">{required}</Text>
          </div>
          <div className="flex justify-between items-center">
            <Text className="text-gray-500">Your Balance</Text>
            <Button
              type="link"
              className={`p-0 h-auto font-semibold ${balance > 0 ? 'text-blue-600' : 'text-red-600'}`}
              onClick={() => {
                onClose();
                navigate('/credits');
              }}
            >
              {balance}
            </Button>
          </div>
          <div className="border-t pt-3 flex justify-between items-center">
            <Text className="text-gray-500">Shortage</Text>
            <Text strong className="text-red-600">
              {required - balance} credits
            </Text>
          </div>
        </div>

        <div className="mt-4 p-3 bg-blue-50 rounded-lg">
          <Text className="text-blue-700 text-sm">
            Please contact your administrator to top up your credits or upgrade your plan.
          </Text>
        </div>
      </div>
    </Modal>
  );
};

export default InsufficientCreditsModal;
